module.exports = __webpack_public_path__ + "img/2.fefeb9d3.png";